import { heroStats } from '../data/mock';

export default function Manifesto() {
  return (
    <section id="insights" className="relative px-5 md:px-10 lg:px-14 py-24 md:py-40">
      <div className="flex items-center gap-4 mb-10">
        <span className="w-10 h-px bg-[#FF3D2E]" />
        <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/70">01 / MANIFESTO</p>
      </div>

      <div className="max-w-6xl">
        <h2 className="font-display text-[8vw] md:text-[5.5vw] lg:text-[5rem] xl:text-[6rem] leading-[0.95] tracking-tight">
          <span className="text-white">We don't just build </span>
          <span className="text-white/30">brands.</span>
          <br />
          <span className="text-white">We engineer </span>
          <span className="font-script text-[#FF3D2E]">co-branded cultural moments</span>
          <span className="text-white"> — fusing AI &amp; synthetic intelligence with </span>
          <span className="text-white/30">creator, celebrity</span>
          <span className="text-white"> firepower and ROI you can prove.</span>
        </h2>
      </div>

      {/* Stats */}
      <div className="mt-20 md:mt-28 border-t border-white/10 pt-10 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
        {heroStats.map((s, i) => (
          <div key={i} className="flex flex-col gap-3">
            <div className="font-display text-white text-4xl md:text-5xl lg:text-6xl tracking-tight">
              {s.value}
            </div>
            <p className="text-[10px] md:text-[11px] tracking-[0.25em] text-white/55 max-w-[200px]">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
